<template>
    <main class="col-md-9 float-left col pl-5 pr-2 pl-md-2 pt-2 main" id="content">
        <div class="flex-center position-ref full-height">
            <div class="content">
                <div class="title text-secondary">
                    Sorry, the page you are looking for could not be found.
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        mounted() {
            console.log('Error Page Component mounted.');
        }     
    }
</script>

<style scoped>
    .full-height {
        height: 100vh;
    }

    .flex-center {
        align-items: center;
        display: flex;
        justify-content: center;
    }

    .position-ref {
        position: relative;
    }

    .content {
        text-align: center;
    }

    .title {
        font-size: 36px;
        padding: 20px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ErrorPageComponent.vue